import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

// Renovar token si quedan menos de 30 minutos
function renovarTokenSiNecesario() {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const ahora = Math.floor(Date.now() / 1000);
    const restante = payload.exp - ahora;
    // Si quedan menos de 30 minutos, renovar
    if (restante > 0 && restante < 1800) {
      api.post('/auth/refresh').then(r => {
        if (r.data?.token) localStorage.setItem('token', r.data.token);
      }).catch(() => {});
    }
  } catch (e) {}
}

// Adjuntar token automáticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejar errores globalmente y renovar token
api.interceptors.response.use(
  (res) => {
    // Renovar token en cada respuesta exitosa si está próximo a expirar
    renovarTokenSiNecesario();
    return res;
  },
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
